export default __webpack_public_path__ + "static/media/changepassword.2f18f75c.svg";